import { IButtonStyles } from "@fluentui/react";

export const palette = {
  themePrimary: '#214457',
  themeLighterAlt: '#f2f6f8',
  themeLighter: '#cddce4',
  themeLight: '#a6bfcd',
  themeTertiary: '#61869a',
  themeSecondary: '#31566b',
  themeDarkAlt: '#1e3d4e',
  themeDark: '#193442',
  themeDarker: '#122631',
  neutralLighterAlt: '#faf9f8',
  neutralLighter: '#f3f2f1',
  neutralLight: '#edebe9',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralQuaternary: '#d0d0d0',
  neutralTertiaryAlt: '#c8c6c4',
  neutralTertiary: '#a19f9d',
  neutralSecondary: '#605e5c',
  neutralSecondaryAlt: '#8a8886',
  neutralPrimaryAlt: '#3b3a39',
  neutralPrimary: '#323130',
  neutralDark: '#201f1e',
  black: '#000000',
  white: '#ffffff',
};

// https://paperheartdesign.com/blog/color-palette-peaceful-palettes
// https://coolors.co
// NOTE: background colors are +89 lightness of main color
export const BwjPalette = {
  accentPrimary: '#5DD39E',
  themePrimaryDark: '#051827',
  themeError: '#A72608',
  themeErrorBackground: '#F5E6E3',
  themeWarning: '#E8871E',
  themeWarningBackground: '#FCF1E5',
  themeWarningBackgroundDark: '#EDB458',
  themeInfo: '#0496FF',
  themeInfoBackground: '#E2F3FF',
  themeSuccess: '#248232',
  themeSuccessBackground: '#E3F3E6',
};

export const fonts = {
  medium: {
    fontSize: '16px'
  },
};

const buttonStyles: IButtonStyles = {
  root: {
    height: 40,
  }
}
export const components = {
  PrimaryButton: { styles: buttonStyles },
  DefaultButton: { styles: buttonStyles },
};

export const fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans','Droid Sans', 'Helvetica Neue', sans-serif";